import React, { FC, useState } from 'react';
import { Brand, BrandVenueType } from '@go-shared/types/brand';
import { Button, Checkbox } from '@spark-labs/avocado-ui';

interface VenueTypesFormProps {
  brand: Brand;
  onSubmit: (venueTypes: BrandVenueType[]) => void;
}

const VenueTypesForm: FC<VenueTypesFormProps> = ({ brand, onSubmit }) => {
  // clone venue types
  let [venueTypes, setVenueTypes] = useState<BrandVenueType[]>(
    brand.venueTypes.map(vt => ({ ...vt }))
  );

  const toggleVenueTypeDisplay = (vt: BrandVenueType) => {
    vt.hideFromSignage = !vt.hideFromSignage;
    setVenueTypes(Array.from(venueTypes));
  };

  const submitForm = () => {
    onSubmit(venueTypes);
  };

  return (
    <div className="border-t border-grey pt-2 p-4 mt-6" style={{ width: '600px' }}>
      <div className="w-full flex flex-col">
        <div className="w-full p-4">
          <table className="w-full">
            <thead>
              <tr>
                <th className="text-left">Venue Type</th>
                <th className="text-left">Hide from Digital Endpoints</th>
              </tr>
            </thead>
            <tbody>
              {venueTypes.map(vt => (
                <tr key={vt._id}>
                  <td>{vt.name}</td>
                  <td>
                    <Checkbox
                      value={vt._id}
                      checked={!!vt.hideFromSignage}
                      onChange={() => toggleVenueTypeDisplay(vt)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex justify-end">
          <div className="mx-2">
            <Button color="green" onClick={submitForm}>
              Submit
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VenueTypesForm;
